/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { baseRequest } from 'blb-api/baseRequest';
let CONFIG;
export const getConfig = () => CONFIG;
export const loadConfig = async () => {
  const {
    data
  } = await baseRequest.get('/app-config');
  CONFIG = data;
};